<template>
    <div class="no-print">
        <v-app-bar
            app
            dense
            extended
            color="primary"
            dark
        >
            <v-app-bar-nav-icon
                id="navigationDrawer"
                v-if="$vuetify.breakpoint.smAndDown"
                @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
            <v-app-bar-title>
                <div
                    id="homeLink"
                    small
                    tile
                    class="d-flex align-center gap-1"
                    @click="logoClicked"
                >
                    <v-avatar size="70">
                        <v-img
                            :src="require('@/assets/umf_small_logo.png')"
                            alt="logo"
                        />
                    </v-avatar>
                    <v-card-text
                        v-if="(!isOnExam() && session.getAuthenticated()) && ($vuetify.breakpoint.smAndUp || $vuetify.breakpoint.lgAndUp) && !$vuetify.breakpoint.mdOnly"
                    >
                        <span class="text-start">Universitatea de Medicină, Farmacie, Științe și Tehnologie</span>
                        <div class="text-start">
                            <strong>"George Emil Palade"</strong> Târgu Mureș
                        </div>
                    </v-card-text>
                </div>
            </v-app-bar-title>
            <v-spacer></v-spacer>
            <template v-if="$vuetify.breakpoint.mdAndUp && !isOnExam()">
                <Btn
                    text
                    id="examsSimulation"
                    v-if="session.isStudent() && session.getExamVisibility('FALSE') && canSimulate"
                    to="/examSimulation"
                    :title="$t('examSimulation')"
                />
                <Btn
                    text
                    id="scheduleExams"
                    v-if="session.isStudent() && session.getExamVisibility('FALSE')"
                    to="/examAppointments"
                    :title="$t('examAppointments')"
                />
                <Btn
                    text
                    id="examsResult"
                    v-if="session.isStudent() && session.getExamVisibility('FALSE')"
                    to="examsPreview"
                    :title="$t('examS')"
                />
                <v-menu offset-y v-if="session.isAdmin() && session.getExamVisibility('FALSE')" >
                    <template v-slot:activator="{ on, attrs }">
                        <Btn
                            :title="$t('Admin')"
                            text
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-list
                        nav
                        dense
                        flat
                        tile
                    >
                        <v-list-item
                            active-class="active-link"
                            to="/admin"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('studentsExam') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/students"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('students') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/sali"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('examrooms') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/examinare"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('examination') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/universityYears"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('universityYears') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/faculties"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('colleges') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/secretars"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('secretars') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/configuration"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('configuration') }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            active-class="active-link"
                            to="/imports"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            <v-list-item-title>
                                {{ $t('imports') }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <Btn
                    text
                    v-if="(session.isTeacher() || session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                    to="/disciplineList"
                    :title="$t('examStructure')"
                />
                <Btn
                    text
                    v-if="(session.isTeacher() || session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                    to="/disciplineManage"
                    :title="$t('disciplineManage')"
                />
                <Btn
                    text
                    v-if="(session.isTeacher()) && session.getExamVisibility('FALSE')"
                    to="/teacherExams"
                    :title="$t('teacherExams')"
                />
                <Btn
                    text
                    v-if="(session.isTeacher()) && session.getExamVisibility('FALSE')"
                    to="/studentsExams"
                    :title="$t('studentsExams')"
                />
                <Btn
                    text
                    v-if="(session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                    to="/customExams"
                    :title="$t('customExams')"
                />
                <Btn
                    text
                    v-if="(session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                    to="/appointments"
                    :title="$t('appointments')"
                />
                <Btn
                    text
                    v-if="session.isTeacher() && session.getExamVisibility('FALSE')"
                    to="/contestations"
                    :title="$t('examsContest')"
                />
                <Btn
                    text
                    v-if="session.isSecretar() && session.getExamVisibility('FALSE')"
                    to="/students"
                    :title="$t('students')"
                />
                <Btn
                    text
                    v-if="session.isSecretarGeneral() && session.getExamVisibility('FALSE')"
                    to="/secretars"
                    :title="$t('secretars')"
                />
                <Btn
                    text
                    v-if="session.hasStatisticsAccess() &&  !session.isStudent() && session.getExamVisibility('FALSE')"
                    to="/statistics"
                    :title="$t('statistics')"
                />
                <v-menu offset-y>
                    <template #activator="{ on, attrs }">
                        <Btn
                            icon="account"
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-list dense>
                        <v-list-item
                            v-if="session.getAuthenticated() == 'true' && session.getExamVisibility('FALSE')"
                            to="/dashboard"
                        >
                            {{ $t("dashboard") }}
                        </v-list-item>
                        <v-list-item
                            title="Theme"
                            @click="toggleDarkMode()"
                        >
                            {{ $t('switchTheme') }}
                        </v-list-item>
                        <v-list-item
                            :title="$t('logout')"
                            @click="session.logout()"
                            v-if="session.getAuthenticated() == 'true'"
                        >
                            <Btn
                                color="error"
                                :title="$t('logout')"
                                icon="logout"
                            />
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-app-bar>
        <!-- NAVIGATION DRAWER -->
        <v-navigation-drawer
            v-model="drawer"
            fixed
        >
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-avatar size="120">
                        <v-avatar size="120">
                            <v-img
                                :class="{ negative: !$vuetify.theme.dark }"
                                :src="require('@/assets/umf_small_logo.png')"
                                alt="logo"
                            />
                        </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-title class="text-h6">
                        UMFST
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        "George Emil Palade" Târgu Mureș
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list
                nav
                dense
                v-if="session.getAuthenticated() == 'true'"
            >
                <v-list-item-group v-if="session.getExamVisibility('FALSE')">
                    <v-list-item
                        id="homeLink"
                        v-if="session.getAuthenticated() == 'true' && session.getExamVisibility('FALSE')"
                        to="/dashboard"
                    >
                        {{ $t("dashboard") }}
                    </v-list-item>
                    <v-list-item
                        id="examsSimulation"
                        v-if="session.getAuthenticated() == 'true' &&
                            session.getExamVisibility('FALSE') && session.isStudent() && canSimulate
                            "
                        to="/examSimulation"
                    >
                        {{ $t("examSimulation") }}
                    </v-list-item>
                    <v-list-item
                        id="scheduleExams"
                        v-if="session.getAuthenticated() == 'true' &&
                            session.getExamVisibility('FALSE') && session.isStudent()
                            "
                        to="/examAppointments"
                    >
                        {{ $t("examAppointments") }}
                    </v-list-item>
                    <v-list-item
                        id="examsResult"
                        v-if="session.isStudent() && session.getExamVisibility('FALSE')"
                        to="examsPreview"
                    >
                        {{ $t("examS") }}
                    </v-list-item>
                    <v-list-group no-action v-if="session.isAdmin()">
                        <template v-slot:activator>
                            <v-list-item-content>
                                {{ $t("Admin") }}
                            </v-list-item-content>
                        </template>

                        <v-list-item
                            to="/admin"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('studentsExam') }}
                        </v-list-item>
                        <v-list-item
                            to="/students"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('students') }}
                        </v-list-item>
                        <v-list-item
                            to="/sali"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('examrooms') }}
                        </v-list-item>
                        <v-list-item
                            to="/examinare"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('examination') }}
                        </v-list-item>
                        <v-list-item
                            to="/universityYears"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('universityYears') }}
                        </v-list-item>
                        <v-list-item
                            to="/faculties"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('colleges') }}
                        </v-list-item>
                        <v-list-item
                            to="/secretars"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('secretars') }}
                        </v-list-item>
                        <v-list-item
                            to="/configuration"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('configuration') }}
                        </v-list-item>
                        <v-list-item
                            to="/imports"
                            v-if="session.isAdmin() && session.getExamVisibility('FALSE')"
                        >
                            {{ $t('imports') }}
                        </v-list-item>
                    </v-list-group>
                    <v-list-item
                        v-if="(session.isTeacher() || session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                        to="/disciplineList"
                    >
                        {{ $t("examStructure") }}
                    </v-list-item>
                    <v-list-item
                        v-if="(session.isTeacher() || session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                        to="/disciplineManage"
                    >
                        {{ $t("disciplineManage") }}
                    </v-list-item>
                    <v-list-item
                        v-if="(session.isTeacher()) && session.getExamVisibility('FALSE')"
                        to="/teacherExams"
                    >
                        {{ $t("teacherExams") }}
                    </v-list-item>
                    <v-list-item
                        v-if="(session.isTeacher()) && session.getExamVisibility('FALSE')"
                        to="/studentsExams"
                    >
                        {{ $t("studentsExams") }}
                    </v-list-item>
                    <v-list-item
                        v-if="(session.isAdmin() || session.isSecretar() ) && session.getExamVisibility('FALSE')"
                        to="/customExams"
                    >
                        {{ $t("customExams") }}
                    </v-list-item>
                    <v-list-item
                        v-if="(session.isAdmin() || session.isSecretar()) && session.getExamVisibility('FALSE')"
                        to="/appointments"
                    >
                        {{ $t("appointments") }}
                    </v-list-item>
                    <v-list-item
                        v-if="session.isTeacher() && session.getExamVisibility('FALSE')"
                        to="/students"
                    >
                        {{ $t("students") }}
                    </v-list-item>
                    <v-list-item
                        v-if="session.isSecretarGeneral() && session.getExamVisibility('FALSE')"
                        to="/secretars"
                    >
                        {{ $t("secretars") }}
                    </v-list-item>
                    <v-list-item
                        v-if="session.hasStatisticsAccess() && !session.isStudent() && session.getExamVisibility('FALSE')"
                        to="/statistics"
                    >
                        {{ $t("statistics") }}
                    </v-list-item>
                </v-list-item-group>
            </v-list>
            <v-divider v-if="session.getAuthenticated() == 'true' && session.getExamVisibility('FALSE')"></v-divider>
            <v-list dense>
                <v-list-item>
                    <v-icon @click="toggleDarkMode()">mdi-theme-light-dark</v-icon>
                    <v-spacer></v-spacer>
                    <Btn
                        icon="logout"
                        :title="$t('logout')"
                        text
                        color="error"
                        v-if="session.getAuthenticated() == 'true'"
                        @click="session.logout()"
                    />
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- NAVIGATION DRAWER -->
    </div>
</template>

<script>
import { session } from "@/js/session";
import { prepareExam } from "@/js/prepareExam";

export default {
    name: "Header",
    props: {
        darkMode: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            session,
            prepareExam,
            drawer: false,
            canSimulate : false
        };
    },
    async mounted() {
        this.session.setAuthorization();
        this.help = this.$t('help');
        this.canSimulate = await session.getCanSimulate();
    },
    methods: {
        toggleDarkMode() {
            this.$emit('update:darkMode', !this.darkMode);
        },
        isOnExam() {
            return (
                this.session.getAuthenticated() == "true" &&
                ((this.$route.name == "Exam") ||
                    (this.$route.name == "PrepareExam" &&
                        (prepareExam.preparedExam || prepareExam.loading)))
            );
        },
        logoClicked() {
            // if (!this.isOnExam()) {
            //     this.session.replaceRouter("Dashboard");
            // }else{
                location.reload();
            // }
        },
    }
}
</script>

<style>
.uniname {
    font-family: var(--main-font);
    color: var(--secondary);
}

.negative {
    filter: invert(100%);
}

.active-link {
    background-color: lightgray;
    color: black !important;
}</style>